import { darken, alpha, lighten } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles((theme) => ({
    '@global': {
        '.markercluster-map': {
            height: '90vh',
        },
    },

    searchContainer: {
        marginBottom: theme.spacing(0.5),
        borderBottom: `1px solid ${theme.palette.divider}`,

        '& .MuiInputBase-input': {
            padding: '6px 0 5px',
        },
    },

    mapContainer: {
        position: 'relative',
        height: (props) => (props.isPrinting ? 768 : 'auto'),
    },

    map: {
        '& .leaflet-tile-pane': {
            filter: theme.palette.type === 'light' ? 'none' : 'invert(100%) hue-rotate(193deg) saturate(0.6)',
        },

        '&.leaflet-container': {
            width: '100%',
            background: theme.palette.type === 'light' ? 'rgb(152, 188, 218)' : 'rgb(59, 74, 97)',
        },

        '& .leaflet-bar a': {
            background:
                theme.palette.type === 'light'
                    ? darken(theme.palette.background.paper, 0.02)
                    : lighten(theme.palette.background.paper, 0.03),
            color: theme.palette.text.primary,
            lineHeight: '27px',

            borderBottomColor:
                theme.palette.type === 'light'
                    ? darken(theme.palette.background.paper, 0.1)
                    : lighten(theme.palette.background.paper, 0.1),
        },

        '& .leaflet-bar': {
            border: 'none',
        },

        '& .leaflet-control': {
            '& a:hover': {
                textDecoration: 'none',
            },

            '@media print': {
                display: 'none',
            },
        },

        '& .leaflet-tooltip': {
            background: alpha(theme.palette.background.paper, 0.9),

            borderColor:
                theme.palette.type === 'light'
                    ? darken(theme.palette.background.paper, 0.2)
                    : lighten(theme.palette.background.paper, 0.13),

            '&.leaflet-tooltip-top:before': {
                borderTopColor: alpha(theme.palette.background.paper, 0.9),
            },
        },

        height: (props) => (props.isPrinting ? '100%' : 'auto'),
    },

    controlButton: {
        cursor: 'pointer',
    },

    controlIcon: {
        marginTop: '5px',
    },

    geoJSON: {
        '&.leaflet-interactive': {
            cursor: 'grab',
        },
    },
}));
